import { Check, TriangleAlert } from 'lucide-react';
import toast from 'react-hot-toast';

interface ToastOptions {
  duration?: number;
  style?: React.CSSProperties;
  className?: string;
  position?:
    | 'top-left'
    | 'top-center'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-center'
    | 'bottom-right';
}

export const showToast = {
  success: (message: React.ReactElement | string, options?: ToastOptions) =>
    toast.success(message, {
      ...options,
      icon: <Check size={25} color="white" style={{ paddingLeft: 6 }} />,
      style: {
        backgroundColor: '#28A745',
        color: '#FFFFFF',
        fontWeight: '500',
        letterSpacing: 0.5,
        padding: 2,
        // textTransform: 'capitalize',
      },
    }),

  error: (message: string, options?: ToastOptions) =>
    toast.error(message, {
      ...options,
      icon: <TriangleAlert size={25} color="white" style={{ paddingLeft: 6 }} />,
      style: {
        backgroundColor: '#E22626',
        color: '#FFFFFF',
        fontWeight: '500',
        letterSpacing: 0.5,
        padding: 2,
        // textTransform: 'capitalize',
      },
    }),

  loading: (message: string, options?: ToastOptions) =>
    toast.loading(message, {
      ...options,
    }),

  info: (message: string, options?: ToastOptions) =>
    toast(message, {
      ...options,
    }),

  warning: (message: string, options?: ToastOptions) =>
    toast(message, {
      ...options,
      style: {
        backgroundColor: '#ff9100ff',
        color: '#FFFFFF',
        fontWeight: '500',
        letterSpacing: 0.5,
        padding: 2,
        // textTransform: 'capitalize',
      },
    }),

  dismiss: (id?: string) => toast.dismiss(id),
};
